/*
 * collection-template-new.js  ·  Oath Jewelry  ·  Phase 5 (Handoff E)
 *
 * Controller for the premium collection filter toolbar. Loaded with `defer`.
 *
 * Multi-select itself needs no JavaScript: each filter option is a native
 * Shopify filter link (value.url_to_add / value.url_to_remove) that performs
 * a full-page reload and accumulates parameters across filters. This script
 * only handles the interactive chrome:
 *   - dropdown open / close (click, Escape, outside-click, arrow keys)
 *   - price min/max apply + clear
 *   - sort change
 *   - mobile "Filters" reveal
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    var root = document.querySelector('[data-oath-filters]');
    if (!root) return;

    var dropdowns = Array.prototype.slice.call(root.querySelectorAll('[data-oath-filter]'));

    function closeDropdown(d) {
      var trigger = d.querySelector('[data-oath-trigger]');
      var panel = d.querySelector('[data-oath-panel]');
      d.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    }

    function closeAll(except) {
      dropdowns.forEach(function (d) {
        if (d !== except) closeDropdown(d);
      });
    }

    dropdowns.forEach(function (d) {
      var trigger = d.querySelector('[data-oath-trigger]');
      var panel = d.querySelector('[data-oath-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var willOpen = !d.classList.contains('is-open');
        closeAll(d);
        if (willOpen) {
          d.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        } else {
          closeDropdown(d);
        }
      });

      // Keep clicks inside the panel from bubbling to the document closer.
      panel.addEventListener('click', function (e) { e.stopPropagation(); });

      // Roving arrow-key navigation between options + Escape to close.
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDropdown(d);
          trigger.focus();
          return;
        }
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var opts = Array.prototype.slice.call(
          panel.querySelectorAll('.oath-filter__option:not(.is-disabled), .oath-price__input, .oath-price__apply, .oath-price__clear')
        );
        if (!opts.length) return;
        e.preventDefault();
        var idx = opts.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') (opts[idx + 1] || opts[0]).focus();
        else (opts[idx - 1] || opts[opts.length - 1]).focus();
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDropdown(d);
      });
    });

    // Outside click closes any open dropdown.
    document.addEventListener('click', function () { closeAll(null); });

    /* ---- Price filter ---- */
    var priceMin = root.querySelector('[data-oath-price-min]');
    var priceMax = root.querySelector('[data-oath-price-max]');
    var priceApply = root.querySelector('[data-oath-price-apply]');
    var priceClear = root.querySelector('[data-oath-price-clear]');

    function go(url) {
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }

    function applyPrice() {
      var url = new URL(window.location.href);
      var min = priceMin && priceMin.value !== '' ? priceMin.value : null;
      var max = priceMax && priceMax.value !== '' ? priceMax.value : null;
      if (min !== null) url.searchParams.set('filter.v.price.gte', min);
      else url.searchParams.delete('filter.v.price.gte');
      if (max !== null) url.searchParams.set('filter.v.price.lte', max);
      else url.searchParams.delete('filter.v.price.lte');
      go(url);
    }

    if (priceApply) {
      priceApply.addEventListener('click', function (e) { e.preventDefault(); applyPrice(); });
    }
    [priceMin, priceMax].forEach(function (inp) {
      if (!inp) return;
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); applyPrice(); }
      });
    });
    if (priceClear) {
      priceClear.addEventListener('click', function (e) {
        e.preventDefault();
        var url = new URL(window.location.href);
        url.searchParams.delete('filter.v.price.gte');
        url.searchParams.delete('filter.v.price.lte');
        go(url);
      });
    }

    /* ---- Sort ---- */
    var sort = root.querySelector('[data-oath-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        if (this.value) url.searchParams.set('sort_by', this.value);
        else url.searchParams.delete('sort_by');
        go(url);
      });
    }

    /* ---- Mobile reveal ---- */
    var mobileToggle = root.querySelector('[data-oath-mobile-toggle]');
    var groups = root.querySelector('[data-oath-groups]');
    if (mobileToggle && groups) {
      mobileToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = groups.classList.toggle('is-open');
        mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  });
})();
